import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap/dist/js/bootstrap.min.js' //注意：通常你只需要引入bootstrap的js一次，下面这行和bootstrap.bundle.min.js是重复的，请选择一个使用
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'font-awesome/css/font-awesome.min.css'
import './assets/js/global.js'
import './assets/css/global.css'
import { formatTimeAgo } from './utils'
const app = createApp(App)

// 将formatTimeAgo添加到全局属性中  
app.config.globalProperties.$formatTimeAgo = formatTimeAgo
app.use(router)
app.mount('#app')
